import React from "react";
import { Page } from '../../components/page';
import { CardSimple } from "../../ui";
import { useNavigate } from 'react-router-dom';
import ExampleGif from '../landing-page/lp_gif.gif';
import logo from '../../ui/assets/logo.png';
import { IT } from 'country-flag-icons/react/3x2';
import { useLang } from '../../libs';

import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';
import CloudUploadOutlinedIcon from '@mui/icons-material/CloudUploadOutlined';
import TouchAppOutlinedIcon from '@mui/icons-material/TouchAppOutlined';
import BusinessCenterOutlinedIcon from '@mui/icons-material/BusinessCenterOutlined';
import ArrowForwardOutlinedIcon from '@mui/icons-material/ArrowForwardOutlined';
import EventOutlinedIcon from '@mui/icons-material/EventOutlined';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import CardGiftcardOutlinedIcon from '@mui/icons-material/CardGiftcardOutlined';
import ContactMailOutlinedIcon from '@mui/icons-material/ContactMailOutlined';
import ShieldOutlinedIcon from '@mui/icons-material/ShieldOutlined';
import PaymentOutlinedIcon from '@mui/icons-material/PaymentOutlined';
import FlagOutlinedIcon from '@mui/icons-material/FlagOutlined';
import SmartphoneOutlinedIcon from '@mui/icons-material/SmartphoneOutlined';
import CloudSyncOutlinedIcon from '@mui/icons-material/CloudSyncOutlined';
import AutoAwesomeOutlinedIcon from '@mui/icons-material/AutoAwesomeOutlined';
import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookIcon from '@mui/icons-material/Facebook';
import YouTubeIcon from '@mui/icons-material/YouTube';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';

const translations = {
    it: {
        heroTitle: "La foto che prende vita con un tocco",
        heroText: <>Foto stampate con <strong>tecnologia NFC</strong> collegate a uno spazio cloud privato. Avvicina lo smartphone e accedi ai tuoi contenuti digitali.</>,
        heroSubtext: <><strong>Nessuna app da scaricare. Nessun QR code. Solo un tocco.</strong></>,
        heroAlt: "Demo Kangury: sfiora la foto e accedi al cloud",
        buyNow: "Acquista ora",
        discoverBusiness: "Scopri per il Business",
        howItWorks: "Come Funziona",
        step1Title: "1. Scegli la foto",
        step1Text: "Seleziona il formato, la foto e la cornice che preferisci. Te la consegniamo a casa.",
        step2Title: "2. Carica i contenuti",
        step2Text: "Ogni foto include uno spazio cloud privato dove salvare foto, video e ricordi. Per sempre.",
        step3Title: "3. Sfiora e rivivi",
        step3Text: "Avvicina lo smartphone alla foto e accedi istantaneamente ai tuoi contenuti digitali.",
        b2bTitle: "Kangury per le Agenzie",
        b2bText: <>Trasforma le campagne dei tuoi clienti con il <strong className="text-primary">gadget promozionale</strong> che unisce il mondo fisico a quello digitale. Un tocco e i contenuti prendono vita.</>,
        b2bUseCase1: "Gadget per fiere ed eventi",
        b2bUseCase2: "Smart flyer NFC",
        b2bUseCase3: "Welcome kit aziendali",
        b2bUseCase4: "Biglietti da visita evoluti",
        b2bAllUseCases: <>Scopri tutti i casi d{"'"}uso <ArrowForwardOutlinedIcon className="ms-1" style={{ fontSize: '18px' }} /></>,
        b2bFreeSample: "Campione gratuito",
        b2bWowTitle: "Effetto WOW garantito",
        b2bWowText1: "I gadget tradizionali finiscono nel cestino.",
        b2bWowText2: <>Una foto Kangury viene <strong className="text-primary">conservata e interagita</strong>: il destinatario la tocca e accede a video, cataloghi, offerte.</>,
        b2bWowPricing: <>Pricing da <strong className="text-primary">{"\u20AC"}2/pezzo</strong> per grandi volumi</>,
        whyKangury: "Perch\u00E9 Kangury",
        whyMadeInItaly: "Made in Italy",
        whyMadeInItalyText: "Prodotto e spedito dall'Italia, con la qualit\u00E0 e la cura del design italiano.",
        whyNoCost: "Nessun costo ricorrente",
        whyNoCostText: "Paghi una volta, il cloud è incluso per sempre. Nessun abbonamento nascosto.",
        whyProtect: "Proteggi i tuoi ricordi",
        whyProtectText: "I tuoi file al sicuro per sempre, accessibili con un semplice tocco della foto.",
        whyUpdatable: "Contenuti aggiornabili",
        whyUpdatableText: "Aggiorna il cloud anche dopo aver ricevuto la foto. I contenuti restano sempre freschi.",
        whyCompatible: "Compatibile con il 95%+ degli smartphone",
        whyCompatibleText: "Funziona con la stragrande maggioranza degli smartphone in circolazione.",
        whyNoQR: "Nessun QR code, basta un tocco",
        whyNoQRText: "Tecnologia NFC invisibile: niente codici da inquadrare, esperienza immediata.",
        videoTitle: "Guarda Kangury in azione",
        videoText: "Scopri in pochi secondi come funziona il prodotto che unisce fotografia e tecnologia.",
        ctaTitle: "Pronto a iniziare?",
        ctaText: "Che tu voglia conservare i tuoi ricordi o stupire i clienti della tua agenzia, Kangury ha la soluzione giusta per te.",
        ctaBuyForYou: "Acquista per te",
        ctaBusiness: "Kangury per il Business",
        ctaLearnMore: "Vuoi saperne di pi\u00F9?",
        socialTitle: "Seguici sui nostri social",
        contactTitle: "Per informazioni contattaci:",
        freeSampleSubject: "Richiesta%20campione%20gratuito%20B2B",
    },
    en: {
        heroTitle: "The photo that comes to life with a touch",
        heroText: <>Printed photos with <strong>NFC technology</strong> linked to a private cloud space. Bring your smartphone close and access your digital content.</>,
        heroSubtext: <><strong>No app to download. No QR code. Just a touch.</strong></>,
        heroAlt: "Kangury Demo: touch the photo and access the cloud",
        buyNow: "Buy now",
        discoverBusiness: "Discover for Business",
        howItWorks: "How It Works",
        step1Title: "1. Choose the photo",
        step1Text: "Select the format, photo and frame you prefer. We deliver it to your door.",
        step2Title: "2. Upload your content",
        step2Text: "Each photo includes a private cloud space to save photos, videos and memories. Forever.",
        step3Title: "3. Touch and relive",
        step3Text: "Bring your smartphone close to the photo and instantly access your digital content.",
        b2bTitle: "Kangury for Agencies",
        b2bText: <>Transform your clients' campaigns with the <strong className="text-primary">promotional gadget</strong> that bridges the physical and digital worlds. One touch and content comes to life.</>,
        b2bUseCase1: "Trade fair & event gadgets",
        b2bUseCase2: "NFC smart flyers",
        b2bUseCase3: "Corporate welcome kits",
        b2bUseCase4: "Next-gen business cards",
        b2bAllUseCases: <>Discover all use cases <ArrowForwardOutlinedIcon className="ms-1" style={{ fontSize: '18px' }} /></>,
        b2bFreeSample: "Free sample",
        b2bWowTitle: "Guaranteed WOW effect",
        b2bWowText1: "Traditional gadgets end up in the bin.",
        b2bWowText2: <>A Kangury photo is <strong className="text-primary">kept and interacted with</strong>: the recipient touches it and accesses videos, catalogues, offers.</>,
        b2bWowPricing: <>Pricing from <strong className="text-primary">{"\u20AC"}2/piece</strong> for large volumes</>,
        whyKangury: "Why Kangury",
        whyMadeInItaly: "Made in Italy",
        whyMadeInItalyText: "Produced and shipped from Italy, with the quality and care of Italian design.",
        whyNoCost: "No recurring costs",
        whyNoCostText: "Pay once, cloud included forever. No hidden subscriptions.",
        whyProtect: "Protect your memories",
        whyProtectText: "Your files safe forever, accessible with a simple touch of the photo.",
        whyUpdatable: "Updatable content",
        whyUpdatableText: "Update the cloud even after receiving the photo. Content stays always fresh.",
        whyCompatible: "Compatible with 95%+ of smartphones",
        whyCompatibleText: "Works with the vast majority of smartphones on the market.",
        whyNoQR: "No QR code, just a touch",
        whyNoQRText: "Invisible NFC technology: no codes to scan, instant experience.",
        videoTitle: "Watch Kangury in action",
        videoText: "Discover in seconds how the product that combines photography and technology works.",
        ctaTitle: "Ready to get started?",
        ctaText: "Whether you want to preserve your memories or impress your agency's clients, Kangury has the right solution for you.",
        ctaBuyForYou: "Buy for yourself",
        ctaBusiness: "Kangury for Business",
        ctaLearnMore: "Want to know more?",
        socialTitle: "Follow us on social media",
        contactTitle: "For information, contact us:",
        freeSampleSubject: "Free%20B2B%20sample%20request",
    },
};

export function Home() {
    const navigate = useNavigate();
    const lang = useLang();
    const t = translations[lang];

    return (
        <Page logoOnTop={true}>
            <div className="w-100">

                {/* ===================== HERO SECTION ===================== */}
                <Section>
                    <div className="row align-items-center">
                        <div className="col-12 col-md-6 text-center text-md-start mb-4 mb-md-0">
                            <h1 className="fw-bold text-tertiary mb-3" style={{ lineHeight: 1.2 }}>
                                {t.heroTitle}
                            </h1>
                            <p className="fs-5 text-tertiary mb-2">
                                {t.heroText}
                            </p>
                            <p className="fs-6 mb-4" style={{ color: '#555' }}>
                                {t.heroSubtext}
                            </p>
                            <div className="d-flex gap-3 flex-wrap justify-content-center justify-content-md-start">
                                <button
                                    type="button"
                                    className="btn rounded-5 fs-6 btn-primary text-tertiary fw-bold ps-4 pe-4 pt-2 pb-2"
                                    onClick={() => navigate('/shop')}
                                >
                                    {t.buyNow}
                                </button>
                                <button
                                    type="button"
                                    className="btn rounded-5 fs-6 btn-tertiary text-primary fw-bold ps-4 pe-4 pt-2 pb-2"
                                    onClick={() => navigate('/business')}
                                >
                                    <BusinessCenterOutlinedIcon className="me-1" style={{ fontSize: '18px' }} />
                                    {t.discoverBusiness}
                                </button>
                            </div>
                        </div>
                        <div className="col-12 col-md-6 d-flex justify-content-center">
                            <img
                                src={ExampleGif}
                                alt={t.heroAlt}
                                className="shadow rounded-3"
                                style={{ maxHeight: '420px', width: 'auto', maxWidth: '100%' }}
                            />
                        </div>
                    </div>
                </Section>

                <div className="horizontal-line" />

                {/* ===================== COME FUNZIONA ===================== */}
                <Section bgWhite={true}>
                    <h2 className="fw-bold w-100 text-center mb-5 text-tertiary">
                        {t.howItWorks}
                    </h2>
                    <div className="row">
                        <div className="col-12 col-md-4 mb-4 ps-4 pe-4">
                            <Card
                                title={t.step1Title}
                                text1={t.step1Text}
                                icon={<ShoppingCartOutlinedIcon fontSize="large" className="text-primary mt-4 ms-4 position-absolute top-0 start-0 translate-middle" />}
                            />
                        </div>
                        <div className="col-12 col-md-4 mb-4 ps-4 pe-4">
                            <Card
                                title={t.step2Title}
                                text1={t.step2Text}
                                icon={<CloudUploadOutlinedIcon fontSize="large" className="text-primary mt-4 ms-4 position-absolute top-0 start-0 translate-middle" />}
                            />
                        </div>
                        <div className="col-12 col-md-4 mb-4 ps-4 pe-4">
                            <Card
                                title={t.step3Title}
                                text1={t.step3Text}
                                icon={<TouchAppOutlinedIcon fontSize="large" className="text-primary mt-4 ms-4 position-absolute top-0 start-0 translate-middle" />}
                            />
                        </div>
                    </div>
                </Section>

                <div className="horizontal-line" />

                {/* ===================== B2B SPOTLIGHT ===================== */}
                <div className="w-100 p-4 d-flex justify-content-center align-items-center bg-tertiary pt-5 pb-5">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-12 col-md-7 mb-4 mb-md-0">
                                <div className="d-flex align-items-center mb-3">
                                    <BusinessCenterOutlinedIcon className="text-primary me-2" style={{ fontSize: '36px' }} />
                                    <h2 className="fw-bold text-primary mb-0">
                                        {t.b2bTitle}
                                    </h2>
                                </div>
                                <p className="text-white fs-5 mb-3">
                                    {t.b2bText}
                                </p>
                                <div className="row mb-4">
                                    <div className="col-6 mb-3">
                                        <div className="d-flex align-items-center">
                                            <EventOutlinedIcon className="text-primary me-2" />
                                            <span className="text-white fw-bold">{t.b2bUseCase1}</span>
                                        </div>
                                    </div>
                                    <div className="col-6 mb-3">
                                        <div className="d-flex align-items-center">
                                            <DescriptionOutlinedIcon className="text-primary me-2" />
                                            <span className="text-white fw-bold">{t.b2bUseCase2}</span>
                                        </div>
                                    </div>
                                    <div className="col-6 mb-3">
                                        <div className="d-flex align-items-center">
                                            <CardGiftcardOutlinedIcon className="text-primary me-2" />
                                            <span className="text-white fw-bold">{t.b2bUseCase3}</span>
                                        </div>
                                    </div>
                                    <div className="col-6 mb-3">
                                        <div className="d-flex align-items-center">
                                            <ContactMailOutlinedIcon className="text-primary me-2" />
                                            <span className="text-white fw-bold">{t.b2bUseCase4}</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="d-flex gap-3 flex-wrap">
                                    <button
                                        type="button"
                                        className="btn rounded-5 fs-6 btn-primary text-tertiary fw-bold ps-4 pe-4 pt-2 pb-2"
                                        onClick={() => navigate('/business')}
                                    >
                                        {t.b2bAllUseCases}
                                    </button>
                                    <a
                                        href={`mailto:hello@kangury.it?subject=${t.freeSampleSubject}`}
                                        className="btn rounded-5 fs-6 btn-outline-primary text-primary fw-bold ps-4 pe-4 pt-2 pb-2 text-decoration-none"
                                    >
                                        <EmailOutlinedIcon className="me-1" style={{ fontSize: '18px' }} />
                                        {t.b2bFreeSample}
                                    </a>
                                </div>
                            </div>
                            <div className="col-12 col-md-5 text-center">
                                <div className="bg-tertiary bg-opacity-75 rounded-3 p-4">
                                    <AutoAwesomeOutlinedIcon className="text-primary mb-2" style={{ fontSize: '48px' }} />
                                    <h4 className="text-primary fw-bold mb-3">{t.b2bWowTitle}</h4>
                                    <p className="text-white mb-2">
                                        {t.b2bWowText1}
                                    </p>
                                    <p className="text-white mb-3">
                                        {t.b2bWowText2}
                                    </p>
                                    <div className="text-white" style={{ fontSize: '14px' }}>
                                        {t.b2bWowPricing}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="horizontal-line" />

                {/* ===================== PERCHE KANGURY ===================== */}
                <Section>
                    <h2 className="fw-bold w-100 text-center mb-5 text-tertiary">
                        {t.whyKangury}
                    </h2>
                    <div className="row">
                        <div className="col-12 col-md-6 col-lg-4 mb-4 ps-4 pe-4">
                            <Card
                                title={t.whyMadeInItaly}
                                text1={t.whyMadeInItalyText}
                                icon={<FlagOutlinedIcon fontSize="large" className="text-primary mt-4 ms-4 position-absolute top-0 start-0 translate-middle" />}
                            />
                        </div>
                        <div className="col-12 col-md-6 col-lg-4 mb-4 ps-4 pe-4">
                            <Card
                                title={t.whyNoCost}
                                text1={t.whyNoCostText}
                                icon={<PaymentOutlinedIcon fontSize="large" className="text-primary mt-4 ms-4 position-absolute top-0 start-0 translate-middle" />}
                            />
                        </div>
                        <div className="col-12 col-md-6 col-lg-4 mb-4 ps-4 pe-4">
                            <Card
                                title={t.whyProtect}
                                text1={t.whyProtectText}
                                icon={<ShieldOutlinedIcon fontSize="large" className="text-primary mt-4 ms-4 position-absolute top-0 start-0 translate-middle" />}
                            />
                        </div>
                        <div className="col-12 col-md-6 col-lg-4 mb-4 ps-4 pe-4">
                            <Card
                                title={t.whyUpdatable}
                                text1={t.whyUpdatableText}
                                icon={<CloudSyncOutlinedIcon fontSize="large" className="text-primary mt-4 ms-4 position-absolute top-0 start-0 translate-middle" />}
                            />
                        </div>
                        <div className="col-12 col-md-6 col-lg-4 mb-4 ps-4 pe-4">
                            <Card
                                title={t.whyCompatible}
                                text1={t.whyCompatibleText}
                                icon={<SmartphoneOutlinedIcon fontSize="large" className="text-primary mt-4 ms-4 position-absolute top-0 start-0 translate-middle" />}
                            />
                        </div>
                        <div className="col-12 col-md-6 col-lg-4 mb-4 ps-4 pe-4">
                            <Card
                                title={t.whyNoQR}
                                text1={t.whyNoQRText}
                                icon={<TouchAppOutlinedIcon fontSize="large" className="text-primary mt-4 ms-4 position-absolute top-0 start-0 translate-middle" />}
                            />
                        </div>
                    </div>
                </Section>

                <div className="horizontal-line" />

                {/* ===================== VIDEO SECTION ===================== */}
                <Section bgWhite={true}>
                    <h2 className="fw-bold w-100 text-center mb-4 text-tertiary">
                        {t.videoTitle}
                    </h2>
                    <p className="text-center mb-4" style={{ color: '#555' }}>
                        {t.videoText}
                    </p>
                    <div className="mt-2">
                        <div style={{ padding: 0, width: '100%', position: 'relative', paddingTop: '56.2069%' }}>
                            <iframe
                                style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
                                allowFullScreen=""
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                referrerPolicy="strict-origin-when-cross-origin"
                                title="PhotoK By Kangury"
                                src="https://www.youtube.com/embed/X8F34Fw-c0E?autoplay=0&loop=0&rel=0&enablejsapi=1&origin=https%3A%2F%2Flaunch.kangury.it&widgetid=1"
                            />
                        </div>
                    </div>
                </Section>

                <div className="horizontal-line" />

                {/* ===================== CTA FINALE ===================== */}
                <Section>
                    <div className="text-center text-tertiary">
                        <h2 className="fw-bold mb-3">{t.ctaTitle}</h2>
                        <p className="fs-5 mb-4" style={{ maxWidth: '600px', margin: '0 auto' }}>
                            {t.ctaText}
                        </p>
                        <div className="d-flex justify-content-center gap-3 flex-wrap mb-3">
                            <button
                                type="button"
                                className="btn rounded-5 fs-6 btn-primary text-tertiary fw-bold ps-4 pe-4 pt-2 pb-2"
                                onClick={() => navigate('/shop')}
                            >
                                {t.ctaBuyForYou}
                            </button>
                            <button
                                type="button"
                                className="btn rounded-5 fs-6 btn-tertiary text-primary fw-bold ps-4 pe-4 pt-2 pb-2"
                                onClick={() => navigate('/business')}
                            >
                                <BusinessCenterOutlinedIcon className="me-1" style={{ fontSize: '18px' }} />
                                {t.ctaBusiness}
                            </button>
                        </div>
                        <div className="mt-2">
                            <span
                                className="text-decoration-underline cursor-pointer"
                                style={{ color: '#555' }}
                                onClick={() => navigate('/how-it-works')}
                            >
                                {t.ctaLearnMore}
                            </span>
                        </div>
                    </div>
                </Section>

                {/* ===================== SOCIAL / CONTACT FOOTER ===================== */}
                <div className="w-100 p-4 d-flex justify-content-center align-items-center bg-tertiary bg-opacity-50 pt-5 pb-5">
                    <div className="container">
                        <h2 className="fw-bold w-100 text-center mb-3 text-tertiary">
                            {t.socialTitle}
                        </h2>
                        <div className="d-flex justify-content-center align-items-center gap-4 mb-4">
                            <a href="https://www.instagram.com/kanguryapp/" target="_blank" rel="noreferrer">
                                <InstagramIcon fontSize="large" className="text-primary" />
                            </a>
                            <a href="https://www.facebook.com/profile.php?id=61563829343302" target="_blank" rel="noreferrer">
                                <FacebookIcon fontSize="large" className="text-primary" />
                            </a>
                            <a href="https://www.youtube.com/@kangury" target="_blank" rel="noreferrer">
                                <YouTubeIcon fontSize="large" className="text-primary" />
                            </a>
                        </div>
                        <div className="d-flex justify-content-center align-items-center mb-3">
                            <IT style={{ height: '15px' }} />
                            <em className="me-2 ms-2">Made in Italy</em>
                            <IT style={{ height: '15px' }} />
                        </div>
                        <h5 className="fw-bold w-100 text-tertiary text-center">
                            {t.contactTitle}
                        </h5>
                        <div className="fs-5 text-center">
                            <a href="mailto:hello@kangury.it" className="text-tertiary">hello@kangury.it</a>
                        </div>
                    </div>
                </div>

                {/* ===================== COPYRIGHT FOOTER ===================== */}
                <div className="w-100 d-flex justify-content-center align-items-center text-primary bg-tertiary" style={{ padding: '12px 0' }}>
                    <img src={logo} alt="logo" style={{ height: '30px' }} className="pe-none me-2" unselectable="on" />
                    Kangury | Copyright &copy; 2024
                </div>

            </div>
        </Page>
    );
}

const Card = ({ title, text1, text2, otherClass, icon }) => {
    return (
        <CardSimple
            otherClass={otherClass ?? "bg-tertiary bg-opacity-75 position-relative h-100 shadow"}
            children={<div className="text-center">
                <div className="fs-5 fw-bold text-primary">{title}</div>
                <div className="fw-bold text-white">
                    {text1}
                </div>
                {text2 && <div className="fw-bold text-white">
                    {text2}
                </div>}
                {icon}
            </div>} />
    );
}

const Section = ({ children, bgWhite }) => {
    return (
        <div className={`w-100 p-4 d-flex justify-content-center align-items-center ${bgWhite ? 'bg-white' : 'bg-tertiary bg-opacity-25'} pt-5 pb-5`}>
            <div className="container">
                {children}
            </div>
        </div>
    );
}
